import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import LearnMoreModal from '../base/LearnMoreModal';
import { useModalTracker } from '../../../hooks/tracking';
import { ACADEMY_LESSON_IMPORT_CONTACTS_URL, KNOWLEDGE_BASE_IMPORT_CONTACTS_URL } from '../../../utils/urls';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ImportContactsModal = ({
  onClose
}) => {
  const {
    trackLink
  } = useModalTracker('ImportContactsModal');
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.importContacts.heading"
    }),
    illustrationName: "contacts",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.importContacts.description"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.importContacts.p1"
      })
    }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
      onClick: () => trackLink('import contacts article'),
      url: KNOWLEDGE_BASE_IMPORT_CONTACTS_URL,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsx(Link, {
        external: true,
        href: ACADEMY_LESSON_IMPORT_CONTACTS_URL,
        onClick: () => trackLink('import contacts lesson'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.modal.watchVideo"
        })
      })
    })]
  });
};
ImportContactsModal.propTypes = {
  onClose: PropTypes.func
};
export default ImportContactsModal;